export enum TextAlign {
  Left = 'left',
  Center = 'center',
  Right = 'right',
}
